import { MutationTree } from 'vuex';
import { PROJET_LIST } from './mutation-types';
import { initialState as resetState, ProjetListState } from './state';
import { Chantier } from '@/models/Chantier';

export const mutations: MutationTree<ProjetListState> = {
    [PROJET_LIST.SET_LOADING](state: ProjetListState, isLoading: boolean): void {
        state.isLoading = isLoading;
    },
    [PROJET_LIST.SET_ERROR](state: ProjetListState, error: boolean): void {
        state.error = error;
    },
    [PROJET_LIST.ADD_ITEMS](state: ProjetListState, items: Chantier[]): void {
        state.projetList = [...state.projetList, ...items];
    },
    [PROJET_LIST.SET_ITEMS](state: ProjetListState, items: Chantier[]): void {
        state.projetList = items;
    },
    [PROJET_LIST.SET_SCROLL](state: ProjetListState, scroll: number): void {
        state.scroll = scroll;
    },
    [PROJET_LIST.SET_PAGE](state: ProjetListState, page: number): void {
        state.page = page;
    },
    [PROJET_LIST.SET_PAGES](state: ProjetListState, pages: number): void {
        state.pages = pages;
    },
    [PROJET_LIST.SET_FILTER](state: ProjetListState, filter: string): void {
        state.filter = filter;
    },
    [PROJET_LIST.RESET](state: ProjetListState): void {
        Object.assign(state, resetState);
    },
    [PROJET_LIST.SET_SITE_ID](state: ProjetListState, projetId: number): void {
        state.projetId = projetId;
    },
    [PROJET_LIST.RESET_FILTER](state: ProjetListState): void {
        state.filter = '';
    },
};
